import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { distinctUntilChanged } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { iOutChangingStat } from 'src/app/core/interfaces/common';
import { AsEnterpriseService } from 'src/app/core/services/as-enterprise.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
    selector: 'app-upload-multi-file-attachments-moha',
    templateUrl: './upload-multi-file-attachments-moha.component.html',
    styleUrls: ['./upload-multi-file-attachments-moha.component.scss']
})
export class UploadMultiFileAttachmentsMohaComponent implements OnInit, iOutChangingStat, OnChanges {
    // refresh input file
    @ViewChild('inputUpload', { read: '', static: false }) inputUploadFile: ElementRef;
    @ViewChild('menuFeature', {static: false}) menuFeature: MatMenu;
    // share data from arr attchment when call method get view detail
    @Input() arrAttachments: any[];
    @Input() typeCreateContract: number;
    @Input() isEdit: boolean = false;
    @Input() isCopy: number = 0;

    // share data from arr attchment of customer in screen add-document
    @Input() arrAttachmenstOfCustomer: any[];

    // check for view detail
    @Input() isViewDetail: boolean;

    // check for view detail
    @Input() isCustomer: boolean;

    // check for view detail
    @Input() isAttachFileForDocument: boolean;

    @Input() maxSize: number = 10485760;

    @Input() checkMan: any;

    @Input() messageError: string = ''

    // Let parent component this changing status
    @Output() hasChange: EventEmitter<boolean> = new EventEmitter();

    public hasOverride: boolean = false;

    // array file
    listFile: any[] = [];

    maxSizeMessage: string = ''
    maxSizeSystem: number = 0
    // check max size
    maxSizeInput = false;

    // check form changing
    isFormChanging = false;

    /**
     * Check format type file
     */
    errorFormatTypeFile = false;

    isStorageBiggerThan10MBFileSize: boolean = false;
    size10MB: number = 10485760;
    totalResourceCapacityContract10MB: number = 0;
    totalSizeOrigin: number = 0;

    acceptContentType: ContentType[] = [ContentType.PDF, ContentType.BMP, ContentType.JPEG, ContentType.PNG, ContentType.MSG, ContentType.EML, ContentType.RTF, ContentType.XLSX];

    constructor(
        public dialog: MatDialog,
        private commonService: CommonService,
        private message: Message,
        private createContractMohaService: CreateContractMohaService,
        private toastr: ToastrService,
        private contractService: ContractService,
    ) { }
    ngOnChanges(changes: SimpleChanges): void {
        this.maxSizeMessage = this.messageError
            ? this.messageError
            : this.message.getMessage('validation.file');
        if (((changes.arrAttachments && !changes.arrAttachments.firstChange) && this.arrAttachments && this.arrAttachments.length) || (!this.isEdit && !this.isCopy)) {
            let totalSize = 0;
            this.arrAttachments.forEach(attach => {
                if (attach.fileSize !== undefined) {
                    totalSize = totalSize + attach.fileSize;
                } else {
                    totalSize = totalSize + attach.size;
                }
            });

            // if (totalSize > this.maxSize) {
            //     this.maxSizeInput = true;
            // } else {
            //     this.maxSizeInput = false;
            // }

            this.totalSizeOrigin = totalSize;
        }

        if((changes.typeCreateContract && !changes.typeCreateContract.firstChange) || (!this.isEdit && !this.isCopy)) {
            if(this.typeCreateContract) {
                this.createContractMohaService.currentTotalcapacityMainAttachments.pipe(distinctUntilChanged()).subscribe((rs) => {
                    if(rs) {
                        this.getResourceCapacityContract10MB(rs);
                    } else {
                        this.createContractMohaService.fileSizeUp.pipe(distinctUntilChanged()).subscribe((rs) => {
                            if(rs) {
                                this.getResourceCapacityContract10MB(rs);
                            }
                        });
                    }
                });
            } else {
                this.getResourceCapacityContract10MB(0);
            }
        }
    }

    ngOnInit() {
        if (this.arrAttachments === undefined) {
            this.arrAttachments = [];
        }
        this.createContractMohaService.maxSizeSystem.subscribe(res =>{
            if (res) {
                this.maxSizeSystem = res;
            } else {
                this.maxSizeSystem = 0;
            }
        })
        this.createContractMohaService.maxPerAttachFile.subscribe(res =>{
            if (res) {
                this.maxPerAttachFile = res;
            } else {
                this.maxPerAttachFile = 0;
            }
        })
    }

    getResourceCapacityContract10MB(dataMainAttachments: number) {
        this.contractService.getDataCountNumberDocumentOfEnterpriseByService().subscribe((rs) => {
            if(rs && rs.data) {
                if (rs.data.biggerThan10MBFileSize !== undefined) {
                    this.isStorageBiggerThan10MBFileSize = true;
                } else {
                   this.isStorageBiggerThan10MBFileSize = false;
                }
                if(this.isCopy) {
                    if(dataMainAttachments) {
                        if(dataMainAttachments < this.size10MB) {
                            this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize - this.totalSizeOrigin;
                        } else {
                            this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize - dataMainAttachments - this.totalSizeOrigin;
                        }
                    } else {
                        this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize - this.totalSizeOrigin;
                    }
                } else {
                    if(dataMainAttachments) {
                        if(dataMainAttachments < this.size10MB) {
                            this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize;
                        } else {
                            this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize - dataMainAttachments;
                        }
                    } else {
                        this.totalResourceCapacityContract10MB = rs.data.biggerThan10MBFileSize;
                    }
                }
            }
        });
    }

    getFileNew() {
        this.createContractMohaService.dataDocumentParentNewUploadContractAttachments.next(this.arrAttachments);
    }

    // get file from selected file
    async getFiles(e) {
        this.hasOverride = false;
        const attachLengthBeforeUpload: number = this.arrAttachments.length;
        this.maxSizeInput = false;
        this.errorFormatTypeFile = false;

        // simple check mime-type based on file extension
        if (!this.checkFormatTypeFile(e.target.files)) {
            // Check file size of list file when selected upload
            if (!this.totalSize(e.target.files)) {
                await this.checkContentTypeThenAddToList(e.target.files);
            }
        }

        this.reset();
        const hasSucceedFile = this.arrAttachments.length > attachLengthBeforeUpload;
        if (hasSucceedFile) {
            this.setFormChanging(true);
        }
    }

    private async checkContentTypeThenAddToList(files: File[]): Promise<boolean> {
        let r = true;
        await this.checkContentTypeFile(files).then(rs => {
            r = rs;
            if (rs) {
                this.addToList(files);
            }
        });
        return new Promise((resolve, reject) => resolve(r));
    }

    private async checkContentTypeFile(files: File[]): Promise<boolean> {
        let r = true;
        for (const file of files) {
            const ct: ContentType = await FileUtils.getContentType(file);
            if (!this.acceptContentType.includes(ct) && file.type !== 'message/rfc822' ) {
                this.errorFormatTypeFile = true;
                r = false;
                break;
            }
        }
        return new Promise((resolve, reject) => resolve(r));
    }

    private addToList(files: any[]) {
        const duplicateFile: any[] = [];
        for (const file of files) {
            if (this.arrAttachments.length > 0) {
                let check = false;
                for (let j = 0; j < this.arrAttachments.length; j++) {
                    if (this.arrAttachments[j].fileName !== undefined) {
                        if (file.name === this.arrAttachments[j].fileName) {
                            check = true;
                            file.allow = 'INTERNAL'
                            duplicateFile.push(file);
                        }
                    } else {
                        if (file.name === this.arrAttachments[j].name) {
                            file.allow = 'INTERNAL'
                            check = true;
                            duplicateFile.push(file);
                        }
                    }
                }
                if (!check) {
                    file.allow = 'INTERNAL'
                    this.arrAttachments.push(file);
                }
            } else {
                file.allow = 'INTERNAL'
                this.arrAttachments.push(file);
            }
        }
        if (duplicateFile !== undefined && duplicateFile.length > 0) {
            this.showDialog(duplicateFile)
                .afterClosed()
                .subscribe(rs => {
                    if (rs) {
                        this.overriedDuplicated(this.arrAttachments, duplicateFile);
                        this.hasOverride = true;
                        this.setFormChanging(true);
                    }
                });
        }
    }

    checkFormatTypeFile(files): boolean {
        for (let i = 0; i < files.length; i++) {
            if (files[i].type !== 'application/pdf' && files[i].type.slice(0, 6) !== 'image/' 
                && files[i].type !== 'message/rfc822' && files[i].type !== 'application/vnd.ms-outlook' 
                && files[i].type !== 'application/rtf' && files[i].type !== 'application/msword'
                && !(files[i].type == '' && files[i].name.toLowerCase().endsWith('.msg')) && 
                files[i].type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
                files[i].type !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && 
                files[i].type !== 'application/vnd.ms-excel' 
            ) {
                this.errorFormatTypeFile = true;
            }
        }

        if (this.errorFormatTypeFile) {
            return true;
        } else {
            return false;
        }
    }

    // overried file duplicated
    private overriedDuplicated(arrAttach, duplicateFile) {
        duplicateFile = duplicateFile.filter((v, i, a) => a.indexOf(v) === i);
        let dupList = [];
        let pushList = [];
        for (let i = 0; i < arrAttach.length; i++) {
            for (let j = 0; j < duplicateFile.length; j++) {
                if ((arrAttach[i].fileName !== undefined && duplicateFile[j].name === arrAttach[i].fileName) || (arrAttach[i].fileName === undefined && duplicateFile[j].name === arrAttach[i].name)) {
                    dupList.push(arrAttach[i]);
                    pushList.push(duplicateFile[j]);
                }
            }
        }

        dupList.forEach(x => { arrAttach.splice(arrAttach.indexOf(x), 1); });
        pushList.forEach(x => { arrAttach.push(x) });
        this.reset();
    }
    maxPerAttachFile: number = 0;
    // check total max size for all file attachment
    private totalSize(files): boolean {
        let totalSize = 0;
        let tottalSizeNew = 0;
        // List arrAttachments include file old and file new when selected upload
        this.arrAttachments.forEach(attach => {
            if (attach.fileSize !== undefined) {
                totalSize = totalSize + attach.fileSize;
            } else {
                totalSize = totalSize + attach.size;
            }
        });

        for (let i = 0; i < files.length; i++) {
            totalSize = totalSize + files[i].size;
            tottalSizeNew = tottalSizeNew + files[i].size;
        }
        let totalSizeMainAttach = totalSize;

        if(!this.isEdit){
            this.createContractMohaService.mainContractAttactment.getValue().forEach(mainAttach => {
                if (mainAttach.fileSize !== undefined) {
                    totalSizeMainAttach = totalSizeMainAttach + mainAttach.fileSize;
                } else if(mainAttach.size){
                    totalSizeMainAttach = totalSizeMainAttach + mainAttach.size;
                } else if(mainAttach.file){
                    totalSizeMainAttach = totalSizeMainAttach + mainAttach.file.size;
                } else {
                    totalSizeMainAttach = totalSizeMainAttach
                }
            })
        }
        
        if(this.createContractMohaService.document.getValue() && this.isEdit){
            this.createContractMohaService.document.getValue().mainContractAttachments.forEach(mainAttach => {
                if (mainAttach.fileSize !== undefined) {
                    totalSizeMainAttach = totalSizeMainAttach + Number(mainAttach.fileSize);
                }  else {
                    totalSizeMainAttach = totalSizeMainAttach
                }
            })
        }
        
        for (let i = 0; i < files.length; i++) {
            if(files[i].size > this.maxPerAttachFile) {
                this.toastr.error(this.message.getMessage('validation.max_size_file_attach').replace('{0}', String(Math.floor(this.maxPerAttachFile/1024/1024))));
                return true;
            }
        }

        if(totalSizeMainAttach > this.maxSizeSystem){
            this.toastr.error(this.message.getMessage('validation.max_size_file_contract').replace('{0}', String(Math.floor(this.maxSizeSystem/1024/1024))));
            return true
        }
        

        if (this.isStorageBiggerThan10MBFileSize) {
            if(!this.isEdit) {
                if (totalSize > this.maxSizeSystem) {
                    this.maxSizeInput = true;
                    return true;
                } else if (totalSize > this.size10MB && totalSize <= this.maxSizeSystem) {
                    if(totalSize <= this.totalResourceCapacityContract10MB + this.size10MB) {
                        return false;
                    } else {
                        this.toastr.error(this.message.getMessage('validation.validate_attachment_max_size_2'));
                        return true;
                    }
                } else if(this.maxSizeSystem < this.size10MB) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (totalSize > this.maxSizeSystem) {
                    this.maxSizeInput = true;
                    return true;
                } else if(this.totalResourceCapacityContract10MB + this.size10MB <= 0) {
                    this.toastr.error(this.message.getMessage('validation.validate_attachment_max_size_2'));
                    return true;
                } else if(totalSize <= this.size10MB) {
                    this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB - tottalSizeNew;
                    return false;
                } else if (totalSize > this.size10MB && totalSize <= this.maxSizeSystem) {
                    if(totalSize < this.totalSizeOrigin) {
                        this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB - tottalSizeNew;
                        return false;
                    } else if(totalSize > this.totalSizeOrigin) {
                        if(tottalSizeNew < this.totalResourceCapacityContract10MB + this.size10MB) {
                            this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB - tottalSizeNew;
                            return false;
                        } else {
                            this.toastr.error(this.message.getMessage('validation.validate_attachment_max_size_2'));
                            return true;
                        }
                    } else {
                        return false;
                    }
                } else if(this.maxSizeSystem < this.size10MB) {
                    return true;
                } else {
                    return false;
                }
            }
        } else {
            if (totalSize > this.maxSizeSystem) {
                this.maxSizeInput = true;
                return true;
            } else if (totalSize > this.size10MB && totalSize <= this.maxSizeSystem) {
                this.toastr.error(this.message.getMessage('validation.validate_attachment_max_size'));
                return true;
            } else if(this.maxSizeSystem < this.size10MB) {
                return true;
            } else {
                return false;
            }
        }
    }

    // upload multi file
    uploadFile(successCallback: () => void, noUpload: () => void) {
        const fileUpload = this.arrAttachments.filter(
            arrAttachments => arrAttachments.name != undefined);

        if (fileUpload.length > 0) {
            if (this.isCustomer && this.isCustomer != undefined) {
                this.commonService.uploadMultiFileCustomer(fileUpload)
                    .subscribe(rs => {
                        this.uploadFileSuccess(rs, successCallback);
                    });
            } else {
                this.commonService.uploadMultiFile(fileUpload)
                    .subscribe(rs => {
                        this.uploadFileSuccess(rs, successCallback);
                    });
            }
            // }
        } else {
            noUpload();
        }
    }

    // after upload success
    private uploadFileSuccess(rs, successCallback: (data) => void) {
        for (let i = 0; i < rs.data.length; i++) {
            this.arrAttachments.push(rs.data[i]);
        }

        this.arrAttachments = this.arrAttachments.filter(
            arrAttachments => arrAttachments.fileName !== undefined);
        successCallback(this.arrAttachments);
    }

    // remove file from arr listFile for arr file add
    deleteFile(item) {
        this.maxSizeInput = false;
        let totalSize = 0;

        const dialogRef = this.dialog.open(WarningComponent, {
            width: '350px',
            data: this.message.getMessage('popup.confirm_delete_file')
        });
        dialogRef.afterClosed().subscribe(rs => {
            if (rs) {

                this.arrAttachments.forEach(element => {
                    totalSize += (element.size ? element.size : element.fileSize);
                });

                if(this.isEdit && item.fileSize) {
                    if(this.totalResourceCapacityContract10MB > 0) {
                        let currentSize = totalSize - this.size10MB;
                        if(currentSize > 0) {
                            if(currentSize > item.fileSize) {
                                this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB + item.fileSize;
                            } else {
                                this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB + currentSize;
                            }
                        }
                    } else {
                        this.totalResourceCapacityContract10MB = this.totalResourceCapacityContract10MB + item.fileSize;
                        this.totalSizeOrigin = this.totalSizeOrigin - item.fileSize;
                    }
                }

                const index = this.arrAttachments.indexOf(item);
                if (index > -1) {
                    this.arrAttachments.splice(index, 1);
                }

                this.toastr.success(this.message.getMessage('messages.delete_success'));



                this.setFormChanging(true);
                this.reset();
            }
        });
    }

    // show dialog file duplicated
    private showDialog(duplicateFile) {
        let code = '<ul>';

        for (let i = 0; i < duplicateFile.length; i++) {
            if (duplicateFile[i].name !== undefined) {
                code += '<li>' + duplicateFile[i].name + '</li>';
            } else {
                code += '<li>' + duplicateFile[i].fileName + '</li>';
            }
        }

        code += '</ul>';

        const dialogRef = this.dialog.open(WarningComponent, {
            width: '430px',
            data: this.message.getMessage('popup.confirm_override_file') + code,
        });

        return dialogRef;
    }


    // refresh input
    private reset() {
        this.inputUploadFile.nativeElement.value = '';
    }

    donwloadUrl(id: string, fileName: string) {
        if (this.isCustomer && this.isCustomer !== undefined) {
            return this.commonService.downloadFileCustomer(id).subscribe(
                rs => {
                    this.downLoadFile(rs, 'application/octet-stream', fileName);
                }
            );
        } else {
            return this.commonService.downloadFileEnterprises(id).subscribe(
                rs => {
                    this.downLoadFile(rs, 'application/octet-stream', fileName);
                }
            );
        }
    }

    downLoadFile(data: any, type: string, fileName: string) {
        const blob = new Blob([data], { type });
        if (window.top.navigator.msSaveOrOpenBlob) {
            // Store Blob in IE
            window.top.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
            // Store Blob in others
            const tA = document.body.appendChild(document.createElement('a'));
            tA.href = URL.createObjectURL(blob);
            tA.download = fileName;
            tA.style.display = 'none';
            tA.click();
            tA.parentNode.removeChild(tA);
        }
    }

    setFormChanging(changingStatus: boolean) {
        this.isFormChanging = changingStatus;
        this.hasChange.emit(changingStatus);
    }

    checkScope(event: any, data: any){
        data.allow = event
    }
}
